export { default } from "./Float-component";
